import React, {useState,useEffect, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import Modal from '../common/Modal/modal';
import Ratings from '../common/StarRating/ratings'
import * as Toasts from '../common/Toastify';
import { completeCorrectionEncounter, getViewJobDetails, modifyCheckinCheckoutTime, modifyShiftEndTime, saveApproveJob, updateShift } from "./action";
import { setModifyTimeInfo, setPayRateTotalShiftAmount, setPayRateType } from "./slice";
import ModifyCheckTime from '../common/ModifyCheckTime/ModifyCheckTime';
import moment from "moment";
import { viewJobSelector } from "./selector";
import DropDown from "../common/SearchableSelect";
import { refreshMultishiftInfo } from "../ShiftsCoverage/slice";
import ToolTip from "../common/ToolTip/ToolTip";
import { Rating } from "react-simple-star-rating";
import SingleShiftClaimInfo from "./claimedInfo/singleShiftClaimInfo";
import EncounterClaimInfo from "./claimedInfo/encounterClaimInfo";
import MultishiftClaimInfo from "./claimedInfo/multishiftClaimInfo";
import ViewJobInfo from "./ViewJobInfo";
import { formatNumberWithCommas, formatNumberWithoutCommas, handleDecimalValueOnOnChange } from "../../helpers/regEx";
import { payRateTypeObj, shiftTypeObj } from "../../helpers/data";
import { getMinMaxTime } from "../JobOpportunity/transformer";
import DateField from '../common/TextField/dateTime';
import WorkBreakInfo from "./WorkBreakInfo";
import { loadShiftAwaitingCorrection } from "../ShiftsCoverage/action";
const ViewClaimedCandidateInfo = (props) => {
  const {jobId, shiftDate, claimId,jobsShiftUniqueId,shiftEndTime,shiftStartTime,save } = props?.requestData;
  const {masterData,shift, modifyTimeInfo:{checkintime,checkouttime,shiftstarttime,shiftendtime}  } =useSelector(viewJobSelector);
  const isErrorPaymentRate =  useSelector(store => store.viewJobDetails.isErrorPaymentRate)
  const storage = useSessionStorage();
  const [showModal, setShowModal] = useState(false);
  const findPath = useLocation();
  const [notes, setNotes] = useState('');
  const [rating, setRating] = useState(0);
  const [isApproved, setisApproved] = useState(false);
  const [jobsClaimId, setjobsClaimId] = useState(0)
  const [modifyTime, setModifyTime] = useState({
    checkintime: "",
    checkouttime:"",
    shiftstarttime: "",
    shiftendtime:"",
  });
  const claimedInfoRef = useRef(props?.claimedCandidateInfo);
  const payRateTotalShiftAmount = useSelector(store => store.viewJobDetails.payRateTotalShiftAmount);
  const [payRateInputAmount, setPayRateInputAmount] = useState({});
      // Send Mail for mail popup input Error Validation
      const [errorText, setErrorText] = useState();
  const login = storage.getItem('login');
  const dispatch = useDispatch();
  const config = useConfiguration();
  const navigate = useNavigate();
  const showMap = (event, item) => {
    event.preventDefault();
    setShowModal(!showModal);
    if (item) {
        setNotes(item?.notes);
        setRating(item?.rating);
        setisApproved(item?.isApproved);
        setjobsClaimId(item?.jobsClaimId);
    }
};
const closeMap = (event) => {
    event.preventDefault();
    setShowModal(!showModal);
    setNotes('');
    setRating(0);
    setisApproved(false);
    setjobsClaimId(0);
    setErrorText('')
};
const getStarValue = (starValue) => {
    setRating(starValue)
}

  const saveRating = (item) => {
    const params = {
        "jobUniqueId": jobId,
        "appUserUniqueId": login.appUserUniqueId,
        "ratingNumber": rating.toString(),
        "notes": notes,
        "jobsClaimId": jobsClaimId ? jobsClaimId : item?.jobsClaimId ? item?.jobsClaimId : 0,
        "jobsShiftUniqueId": jobsShiftUniqueId
    }

    if (notes?.length > 500) {
    // if (notes && rating) {      
      setErrorText("Please give less then 500 characters")
        
    } 
    // else {
    //     // Toasts.info('Please Give Ratings And Comments');
    //     setErrorText('This field is required!')
    // }
    // } 
    else {
      dispatch(saveApproveJob({ url: config?.baseUrl, params })).then(() => {
        dispatch(getViewJobDetails({url: config?.baseUrl, jobUniqueId: jobId,jobsClaimId:claimId,
          shiftDate:shiftDate})).then(() => dispatch(refreshMultishiftInfo(true)))
    })
    setShowModal(!showModal);
     setNotes('');
    setRating(0);
    setisApproved(false)
    setjobsClaimId(0);
    setErrorText('')
    }


}
useEffect(() => {
  if(props?.save){
    const payRateTotalInputAmount =
    (+props?.jobSummeryJobsShifts?.shiftType ===
    shiftTypeObj?.singleShift)
      ? props?.manualTotalShiftAmount
      : ((+props?.jobSummeryJobsShifts?.shiftType ===
                shiftTypeObj?.multiShift) || (+props?.jobSummeryJobsShifts?.shiftType ===
                  shiftTypeObj?.repost))
      ? props?.manualAmountPerShift
      : null;
    setPayRateInputAmount(payRateTotalInputAmount)
    dispatch(setPayRateTotalShiftAmount(payRateTotalInputAmount));
    dispatch(setPayRateType(props?.payRateType));
  }
},[])

useEffect(() => {
  if(props?.claimedCandidateInfo?.checkedInDate && props?.claimedCandidateInfo?.checkedOutDate){
    setModifyTime(prev => ({...prev, checkintime: props?.claimedCandidateInfo?.checkedInDate, checkouttime: props?.claimedCandidateInfo?.checkedOutDate}))
    dispatch(setModifyTimeInfo({name:"checkintime",value:moment( props?.claimedCandidateInfo?.checkedInDate).format('hh:mm A')}))
    dispatch(setModifyTimeInfo({name:"checkouttime",value:moment( props?.claimedCandidateInfo?.checkedOutDate).format('hh:mm A')}))
  }
  if(props?.claimedCandidateInfo?.jobDate&& props?.claimedCandidateInfo?.jobEndDate){
    setModifyTime(prev => ({...prev,shiftstarttime:props?.claimedCandidateInfo?.jobDate,shiftendtime:props?.claimedCandidateInfo?.jobEndDate}))
    dispatch(setModifyTimeInfo({name:"shiftstarttime",value:moment(props?.claimedCandidateInfo?.jobDate).format('hh:mm A')}))
    dispatch(setModifyTimeInfo({name:"shiftendtime",value:moment(props?.claimedCandidateInfo?.jobEndDate).format('hh:mm A')}))
  }
},[props?.claimedCandidateInfo?.checkedInDate,props?.claimedCandidateInfo?.checkedOutDate,props?.claimedCandidateInfo?.jobDate, props?.claimedCandidateInfo?.jobEndDate])
const maxShiftLengthObj = masterData?.shiftPreferedLength?.at(-1);
const maxShiftLengthHours = (+props?.jobSummeryJobsShifts?.shiftType === shiftTypeObj.multiShift ||+props?.jobSummeryJobsShifts?.shiftType === shiftTypeObj.repost) ? 24 : maxShiftLengthObj?.id ? Math.floor(parseInt(maxShiftLengthObj?.id) / 60) : 26;
const maxShiftLengthMinutes = (+props?.jobSummeryJobsShifts?.shiftType === shiftTypeObj.multiShift ||+props?.jobSummeryJobsShifts?.shiftType === shiftTypeObj.repost) ? 0:maxShiftLengthObj?.id ? maxShiftLengthObj?.id% 60 : 45;
const beforeCheckIn = -15;
const modifyTimeChangeHandler = target => {
  const { value, name } = target;
  // if( name === "shiftstarttime" || name === "shiftendtime"){
  //   const  beginningTime = name === "shiftstarttime" ? value : modifyTime?.shiftstarttime
  //   const endTime =  name === "shiftstarttime" ? modifyTime?.shiftendtime:value;
  //   const diff = Math.abs(new Date(beginningTime) -  new Date(endTime));
  //   const minutes = Math.floor((diff/1000)/60);
  //   if(new Date(beginningTime) > new Date(endTime)) {
  //     Toasts.error(
  //       "Shift start time should not be greater than Shift end time"
  //     );
  //     return
  //   }
  //   const maxHoursInMins = (maxShiftLengthHours * 60) + (maxShiftLengthMinutes);
  //   // if( name === "shiftendtime" && (maxHoursInMins < minutes)){
  //   //   const popShiftEndTime = moment(modifyTime?.shiftstarttime).add(maxShiftLengthHours,'hours').add(maxShiftLengthMinutes,'minutes').toDate()
  //   //   setModifyTime((prev) => ({ ...prev, "shiftendtime": moment(popShiftEndTime).format("YYYY-MM-DDTHH:mm:ss")  }));
  //   //   dispatch(setModifyTimeInfo({name:"shiftendtime",value:moment(popShiftEndTime).format('hh:mm A')}))
  //   //   return;
  //   // }
  // } 
  // if (name === "checkintime" || name === "checkouttime") {
  //   const beginningTime =
  //     name === "checkintime" ? value: modifyTime?.checkintime;
  //   const endTime =
  //     name === "checkintime" ? modifyTime?.checkouttime : value;
  //     // console.log({checInTime:new Date(beginningTime),checkoutTIme:new Date(endTime),value,modifyTime,beginningTime,endTime});
  //   if (new Date(beginningTime) > new Date(endTime)) {
  //     Toasts.error("Check in time should not be greater than Check out time");
  //     return;
  //   }
  // }
  // if(name === "shiftstarttime"){
  //   const popShiftEndTime = moment(value).add(maxShiftLengthHours,'hours').add(maxShiftLengthMinutes,'minutes').toDate()
  //   setModifyTime((prev) => ({ ...prev, "shiftendtime": moment(popShiftEndTime).format("YYYY-MM-DDTHH:mm:ss")  }));
  //   dispatch(setModifyTimeInfo({name:"shiftendtime",value:moment(popShiftEndTime).format('hh:mm A')}))
  // }
  // if(name === "checkintime"){
  //   const popShiftEndTime = moment(value).add(maxShiftLengthHours,'hours').add(maxShiftLengthMinutes,'minutes').toDate()
  //   setModifyTime((prev) => ({ ...prev, "checkouttime": moment(popShiftEndTime).format("YYYY-MM-DDTHH:mm:ss")  }));
  //   dispatch(setModifyTimeInfo({name:"checkouttime",value:moment(popShiftEndTime).format('hh:mm A')}))
  // }
  setModifyTime((prev) => ({ ...prev, [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss")  }));
  dispatch(setModifyTimeInfo({name,value:moment(value).format('hh:mm A')}))
}
const resetCheckTime = () => {
  setModifyTime(prev => ({...prev, checkintime: props?.claimedCandidateInfo?.checkedInDate, checkouttime: props?.claimedCandidateInfo?.checkedOutDate}))
  dispatch(setModifyTimeInfo({name:"checkintime",value:moment( props?.claimedCandidateInfo?.checkedInDate).format('hh:mm A')}))
  dispatch(setModifyTimeInfo({name:"checkouttime",value:moment( props?.claimedCandidateInfo?.checkedOutDate).format('hh:mm A')}))
}
const submitModifyTimeHandler = () => {
  // const  beginningTime = moment(checkintime, 'h:mma');
  // const endTime = moment(checkouttime, 'h:mma');
  // if(endTime.isBefore(beginningTime)){
  //   Toasts.error("Check in time should not be greater than Check out time")
  //   return 
  // }
const beginningTime = modifyTime?.checkintime;
const endTime = modifyTime?.checkouttime;
  if (new Date(beginningTime) >= new Date(endTime)) {
  Toasts.error("Check in time should not be greater than Check out time");
  resetCheckTime();
    return;
    }
  const maxHoursInMins = (maxShiftLengthHours * 60) + (maxShiftLengthMinutes);
  if(modifyTime?.checkouttime && modifyTime?.checkintime){
    const diffTime = new Date(modifyTime?.checkouttime)?.getTime() - new Date(modifyTime?.checkintime)?.getTime();
    const shiftHours = diffTime / (1000 * 60);
    if(shiftHours > maxHoursInMins){
      Toasts.error(`Maximum allowed shift length is ${maxShiftLengthHours} hours ${maxShiftLengthMinutes ? `and ${maxShiftLengthMinutes} mins`:""}. Please select the shift date/time accordingly`);
      resetCheckTime();
      return;
    }
  } 

  dispatch(modifyCheckinCheckoutTime({
      url:config.baseUrl,
      params:{
        "jobsClaimId":claimId,
        "occurenceDate":shiftDate,
        "startDateTime": modifyTime?.checkintime,
        "endDateTime": modifyTime?.checkouttime,
        "jobsShiftUniqueId":jobsShiftUniqueId
      }
    })).then ((response) => {
      if(response){
        dispatch(getViewJobDetails({url: config?.baseUrl, jobUniqueId: jobId,jobsClaimId:claimId,
          shiftDate:shiftDate}))
      } else {
        resetCheckTime();
      }
    })
}
const updateShiftDetails = (target) => {
  const value = target.value;
  if (target.action === 'remove') {
    dispatch(updateShift(target.name, ""));
  } else {
    dispatch(updateShift(target.name, value));
  }
};
const resetShiftTime = () => {
  setModifyTime(prev => ({...prev,shiftstarttime:props?.claimedCandidateInfo?.jobDate,shiftendtime:props?.claimedCandidateInfo?.jobEndDate}))
  dispatch(setModifyTimeInfo({name:"shiftstarttime",value:moment(props?.claimedCandidateInfo?.jobDate).format('hh:mm A')}))
  dispatch(setModifyTimeInfo({name:"shiftendtime",value:moment(props?.claimedCandidateInfo?.jobEndDate).format('hh:mm A')}))
}
const modiftShiftTimeHandler = () => {
  // const  beginningTime = moment(shiftstarttime, 'h:mma');
  // const endTime = moment(shiftendtime, 'h:mma');
  // if(endTime.isBefore(beginningTime)){
  //   Toasts.error("Shift start time should not be greater than Shift end time")
  //   return 
  // }
  const  beginningTime = modifyTime?.shiftstarttime;
  const endTime = modifyTime?.shiftendtime;
  if(new Date(beginningTime) >= new Date(endTime)) {
    Toasts.error(
      "Shift start time should not be greater than Shift end time"
    );
    resetShiftTime()
    return;
  }
  let shiftHours="";
  if(modifyTime.shiftendtime && modifyTime.shiftstarttime){
    const diffTime = new Date(modifyTime.shiftendtime)?.getTime() - new Date(modifyTime.shiftstarttime)?.getTime();
    shiftHours = diffTime / (1000 * 60)
  } else {
    shiftHours = props?.shiftHours
  }
  const maxHoursInMins = (maxShiftLengthHours * 60) + (maxShiftLengthMinutes);
  if(shiftHours > maxHoursInMins){
    Toasts.error(`Maximum allowed shift length is ${maxShiftLengthHours} hours ${maxShiftLengthMinutes ? `and ${maxShiftLengthMinutes} mins`:""}. Please select the shift date/time accordingly`);
    resetShiftTime()
    return;
  }
  dispatch(modifyShiftEndTime({
    url:config.baseUrl,
    params: {
        "jobsClaimId":claimId,
        "occurenceDate":shiftDate,
        "startDateTime":modifyTime?.shiftstarttime,
        "endDateTime":modifyTime?.shiftendtime,
        "jobsShiftUniqueId":jobsShiftUniqueId,
        shiftHours
    }
  })).then ((response) => {
    if(response){
      dispatch(refreshMultishiftInfo(true))
      dispatch(getViewJobDetails({url: config?.baseUrl, jobUniqueId: jobId,jobsClaimId:claimId,
        shiftDate:shiftDate}))
    } else {
      resetShiftTime()
    }
  })
}
const shiftHoursCalc = time => {
  let shiftHours ='';
  const hours = Math.floor(parseInt(time) / 60);
  const minutes = parseInt(time) % 60;
  if(hours){
    shiftHours += `${hours} ${parseInt(hours) ===1 ? 'hr ':'hrs '}`
  }
  if(minutes){
    shiftHours+=`${minutes} mins`
  }
  return shiftHours;
}

const payRateShiftAmountHandler = (e) => {
  dispatch(setPayRateTotalShiftAmount(handleDecimalValueOnOnChange(payRateInputAmount)));
};
const payRateShiftHandler = e => {
  const { name, value } = e.target;
  const removeExistComma = formatNumberWithoutCommas(value);
  const decimalConversion = handleDecimalValueOnOnChange(removeExistComma);
  // const formattedValue = formatNumberWithCommas(decimalConversion);
  setPayRateInputAmount(decimalConversion)
}

const VariablePayRateTable = (
  <table className="table table-responsive">
  <thead>
    <tr>
      <th className="text-capitalize">Start Time</th>
      <th className="text-capitalize">End Time</th>
      <th className="text-capitalize">Candidate Rate</th>
      <th className="text-capitalize">Billing Rate</th>
    </tr>
  </thead>
  <tbody>
    {
      props?.claimedCandidateInfo?.payRates?.map((item, index) => {
        return (
          <tr className="border-bottom mt-2 bg-white">
            <td>{moment(item?.shiftStartTime, "hh:mm").format("hh:mm A")}</td>
            <td>{moment(item?.shiftEndTIme, "hh:mm").format("hh:mm A")}</td>
            <td>{item?.hourlyPayRate}</td>
            <td>{item?.totalRate}</td>
          </tr>
        )
      })
    }
  </tbody>
</table>
)

const completeCorrection = () => {
    if (config.baseUrl) {
      const params = {
        "jobsShiftUniqueId": props?.requestData?.jobsShiftUniqueId
      }
      dispatch(completeCorrectionEncounter(config.baseUrl, params))
      .then((res) => {
        if (res?.result !== 0) {
          props?.closePopup();
          const url = config.baseUrl;
            const empId = login.employerUniqueId;
          dispatch(loadShiftAwaitingCorrection({ url, empId }))
        }
      })
    }
}



  return (
    <section className="card mb-2">
       {
                    showModal && <Modal showHide={closeMap} saveFunction={saveRating} label={"Review"} center={true} size={'lg'}>
                        <div className="row">
                            <div className="form-group">
                                <div className="col-lg-6 col-md-5">
                                    <label htmlFor="Ratings">Shift Rating:</label>
                                    <Ratings
                                        getStarValue={getStarValue}
                                        initialValue={parseFloat(rating)}
                                        showTooltip={true}
                                    />
                                </div>
                                <div className="">
                                    <label htmlFor="exampleFormControlTextarea1">Reviewer comments:</label>
                                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                                         style={{height: "100px"}}
                                        value={notes}
                                        onChange={e => setNotes(e.target.value)}></textarea>
                                  <span className="text-danger">{errorText ? errorText : ""}</span>
                                </div>
                                <div className="col-lg-2 col-md-4">
                                    <label className="form-check-label" style={{ float: 'left' }} htmlFor="flexSwitchCheckDefault">Approve</label>
                                    <div className="form-check form-switch custom-switch-lg" style={{ marginLeft: '15px' }}>
                                        <input className="form-check-input" type="checkbox" checked={isApproved}
                                            onChange={e => setisApproved(e.target.checked)} role="switch" id="flexSwitchCheckDefault" style={{ height: '20px', width: '37px' }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                }
      <div className="card-header d-flex justify-content-between">
                  {
                    (props?.jobSummeryJobsShifts?.shiftType === 1 ||  props?.jobSummeryJobsShifts?.shiftType === 4 ) && <h4 className="mb-0">Single Shift Info</h4>
                    || 
                    props?.jobSummeryJobsShifts?.shiftType === 2 && <h4 className="mb-0">Encounter Info</h4>
                    ||
                    props?.jobSummeryJobsShifts?.shiftType === 3 && <h4 className="mb-0">Multi Shift Info</h4>
                  }
      </div>
      <div className="card-body">
        {/* <div class="row row-cols-1"> */}
          {/* <div class="col-4"> */}
            {/* <div className="row">
                <p className="fw-semibold col-6">Claimed By :</p>
                <label
                  className="col-6"
                  htmlFor={props?.claimedCandidateInfo?.candidateName}
                >
                  {props?.claimedCandidateInfo?.candidateName}
                </label>
            </div> */}
            {/* <div className="row">
                <p className="fw-semibold col-6">Claimed On :</p>
                <label
                  className="col-6"
                  htmlFor={props?.claimedCandidateInfo?.claimedDateToDisplay}
                >
                  {props?.claimedCandidateInfo?.claimedDateToDisplay}
                </label>
            </div> */}
            {/* <div className="row">
                <p className="fw-semibold col-6">Checked In :</p>
                <label
                  className=" col-6"
                  htmlFor={
                    props?.claimedCandidateInfo?.isCheckedIn ? "Yes" : "No"
                  }
                >
                  {props?.claimedCandidateInfo?.isCheckedIn ? "Yes" : "No"}
                </label>
            </div> */}
            {/* While shift type = 2 Not showing this details */}
            {/* {props?.jobSummeryJobsShifts?.shiftType === 2 ? (""): (
            <div className="row">
                <p className="fw-semibold col-6">Checked In Date:</p>
                <label
                  className=" col-6"
                  style={{ background: `${props?.claimedCandidateInfo?.checkInStatus === 2 ? '#ffd300' : '#fff'}` }}
                  htmlFor={props?.claimedCandidateInfo?.checkedInDateToDisplay}
                >
                  {props?.claimedCandidateInfo?.checkedInDateToDisplay}
                </label>
            </div>)} */}
            {/* <div className="row">
                <p className="fw-semibold col-6">Work duration hrs:</p>
                <label
                  className=" col-6"
                  htmlFor= {props?.claimedCandidateInfo?.totalworkedHourToDisplay}
                >
                {props?.claimedCandidateInfo?.totalworkedHourToDisplay}
                </label>
            </div> */}
            {/* While shift type = 2 Not showing this details */}
            {/* {props?.jobSummeryJobsShifts?.shiftType === 2 ? (""): (
            <div className="row">
                  <div className="col-lg-8">
                  { props?.claimedCandidateInfo?.checkedInDate &&  
                props?.claimedCandidateInfo?.checkedOutDate ? (
                  <>
                    <ModifyCheckTime
                      updateValue = {modifyTimeChangeHandler}
                      modifyTime={modifyTime?.checkintime}
                      label={"CheckIn Time:"}
                      name={"checkintime"}
                      isDisabled = {!props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)}
                />
                    <ModifyCheckTime
                      updateValue = {modifyTimeChangeHandler}
                      modifyTime={modifyTime?.checkouttime}
                      label={"Checkout Time:"}
                      name={"checkouttime"}
                      isDisabled = {!props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)}
                />
                <div className="mt-4" style={{cursor:"pointer"}}>
                    <button
                      type="submit"
                      disabled={!props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)}
                      className="btn btn-primary btn-sm "
                      onClick={submitModifyTimeHandler}
                    >
                      Submit
                    </button>
                  </div>
                  </>
                
                )
              :""}
                  </div>
            </div> )} */}
            {/* While only showing the details after check out */}
            {/* {props?.claimedCandidateInfo?.isCheckedOut === true ? (
            <div className="row">
                <p className="fw-semibold col-6">Candidate Billing Hours:</p>
                <label
                  className=" col-6"
                  htmlFor={props?.claimedCandidateInfo?.billingHourToDisplay}
                >
                  {props?.claimedCandidateInfo?.billingHourToDisplay}
                </label>
            </div>) : ("")} */}

          {/* </div> */}
          {/* <div class="col-4"> */}
            {/* <div className="row">
                <p className="fw-semibold col-6">Checked Out :</p>
                <label
                  className=" col-6"
                  htmlFor={
                    props?.claimedCandidateInfo?.isCheckedOut ? "Yes" : "No"
                  }
                >
                  {props?.claimedCandidateInfo?.isCheckedOut ? "Yes" : "No"}
                </label>
            </div> */}
            {/* While shift type = 2 Not showing this details */}
            {/* {props?.jobSummeryJobsShifts?.shiftType === 2 ? (""): (
            <div className="row">
                <p className="fw-semibold col-6">Checked Out Date:</p>
                <label
                  className=" col-6"
                  htmlFor={props?.claimedCandidateInfo?.checkedOutDateToDisplay}
                >
                  {props?.claimedCandidateInfo?.checkedOutDateToDisplay}
                </label>
            </div>)} */}
            {/* <div className="row">
                <p className="fw-semibold col-6">Paid :</p>
                <label
                  className=" col-6"
                  htmlFor={props?.claimedCandidateInfo?.isPaid ? "Yes" : "No"}
                >
                  {props?.claimedCandidateInfo?.isPaid ? "Yes" : "No"}
                </label>
            </div> */}
            {/* <div className="row">
                <p className="fw-semibold col-6">Paid Date :</p>
                <label
                  className=" col-6"
                  htmlFor={props?.claimedCandidateInfo?.paidDateToDisplay}
                >
                  {props?.claimedCandidateInfo?.paidDateToDisplay}
                </label>
            </div> */}

            {/* <div className="row">
                <p className="fw-semibold col-6">Billing rate:</p>
                <label
                  className=" col-6"
                  htmlFor={props?.claimedCandidateInfo?.billingRateToDisplay}
                >
                  {props?.claimedCandidateInfo?.billingRateToDisplay}
                </label>
            </div> */}

            {/* While only showing the details after check out */}
            {/* {props?.claimedCandidateInfo?.isCheckedOut === true ? (
            <div className="row">
                <p className="fw-semibold col-6">Candidate Total Shift Amount:</p>
                <label
                  className=" col-6"
                  htmlFor={props?.claimedCandidateInfo?.totalShiftAmountToDisplay}
                >
                  {props?.claimedCandidateInfo?.totalShiftAmountToDisplay}
                </label>
            </div>): ("")} */}
          {/* </div> */}

          {/* <div class="col-4"> */}
           {/* {
            props?.claimedCandidateInfo?.approversList?.map((item,index) => (
              <React.Fragment key={index}>
                { props?.jobSummeryJobsShifts?.shiftType === 2 ? "" : 
                <div className="row">
                <p className="fw-semibold col-6">Approval :</p>
            <div className="col-6 ">
        
            {props?.claimedCandidateInfo?.isCheckedOut === true &&
                                                <button className="btn btn-primary btn-sm" onClick={(e) => showMap(e, item)}
                                                    disabled={item?.approverUserUniqueId !== login.appUserUniqueId}>Approve</button>
            }
            </div>
            </div>
           }
               <div className="row">
                <p className="fw-semibold col-6">Approver :</p>
                   <label
                  className=" col-6"
                  htmlFor={item?.approverName}
                >
                 {item?.approverName}
                </label>
            </div>
            <div className="row">
                <p className="fw-semibold col-6">Approved Date :</p>
                   <label
                  className=" col-6"
                  htmlFor={item?.approvedDateToDisplay}
                >
                 {item?.approvedDateToDisplay}
                </label>
            </div>
            <div className="row">
                <p className="fw-semibold col-6">Approved :</p>
                   <label
                  className=" col-6"
                  htmlFor={item?.isApproved ? 'Yes' : 'No'}
                >
                 {item?.isApproved ? 'Yes' : 'No'}
                </label>
            </div>
            
              </React.Fragment>
            ))
           } */}
           {/* <div className="row">
                <p className="fw-semibold col-6">Employer bill amount:</p>
                   <label
                  className=" col-6"
                  htmlFor= {props?.claimedCandidateInfo?.employerBillAmountToDisplay}
                >
               {props?.claimedCandidateInfo?.employerBillAmountToDisplay}
                </label>
            </div> */}
          {/* </div> */}

          {/* <div className="row"> */}
            {/* While only showing the details after check out */}
            {/* {props?.claimedCandidateInfo?.isCheckedOut === true ? (
              // While Break Info less then 0 don't Show the details
              props?.candidateBillingsInfo?.breakInfos?.length > 0 ? (
              <div className="col-10">
                <div className="form-group">
                  <label className=" col-6 form-label">Break Info:</label>
                  <div className="d-flex">
                    <div className="col-3 border-bottom">
                      <label className="form-label">Start Time</label>
                    </div>
                    <div className="col-3 border-bottom">
                      <label className="form-label">End Time</label>
                    </div>
                    <div className="col-3 border-bottom">
                      <label className="form-label">Break Duration</label>
                    </div>
                  </div>
                  {props?.candidateBillingsInfo?.breakInfos?.map((item) => (
                    <div className="mt-2">
                      <div className="d-flex">
                        <div className="col-3 border-bottom">
                          <label htmlFor="City">
                            {item.startTimeToDisplay}
                          </label>
                        </div>
                        <div className="col-3 border-bottom">
                          <label htmlFor="City">{item.endTimeToDisplay}</label>
                        </div>
                        <div className="col-3 border-bottom">
                          <label htmlFor="City">
                            {item.breakTimeToDisplay}
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              ) : ( "")

            ) : (
              ""
            )} */}
          {/* </div> */}
          
        {/* </div> */}
        {/* row1-claimed details */}
        {!save ?
        ( props?.jobSummeryJobsShifts?.shiftType === 1 ||  props?.jobSummeryJobsShifts?.shiftType === 4) ? (
              <SingleShiftClaimInfo {...props} />
            ) : props?.jobSummeryJobsShifts?.shiftType === 2 ? (
              <EncounterClaimInfo {...props} />
            ) : props?.jobSummeryJobsShifts?.shiftType === 3 ? (
              <MultishiftClaimInfo
                {...props}
                currentShiftDate={shiftDate}
               
              />
            ) : (
              ""
            ):""}
            {
              save && <div className="row">
                <div className="d-flex">
                <div className="col-3">
                  <label className="form-label">Shift Title:</label>
                  <label htmlFor={props?.jobTitle}>{props.jobTitle}</label>
              </div>
                </div>
              </div>
            }
         {save &&  <div className="row">
          <div className="d-flex">
            <div className="col-2">
            <label className="form-label">Claimed By:</label>
              <label
                    htmlFor={props?.claimedCandidateInfo?.candidateName}
                  >
                    {props?.claimedCandidateInfo?.candidateName}
              </label>
            </div>
            <div className="col-2">
              <label className="form-label">Claimed Date:</label>
              <label
                  htmlFor={props?.claimedCandidateInfo?.claimedDateToDisplay}
                >
                  {props?.claimedCandidateInfo?.claimedDateToDisplay ? moment(props?.claimedCandidateInfo?.claimedDateToDisplay).format(
                      "MM/DD/YYYY"
                    ) : ("")}
              </label>
            </div>
            <div className="col-2">
              <label className="form-label">Claimed Time:</label>
              <label>
                    {props?.claimedCandidateInfo?.claimedDateToDisplay ? moment(props?.claimedCandidateInfo?.claimedDateToDisplay).format("hh:mm A") : ("")}
                  </label>
            </div>
            <div className="col-2">
            {
                  props?.jobSummeryJobsShifts?.shiftType !== 2 ? <>
                    <label className="form-label">Shift Hours :</label>
                    <label htmlFor="shiftHours">
                      {/* {props?.shiftHours} */}
                      {
                        +props?.requestData?.shiftType === shiftTypeObj.singleShift ?   <DropDown
                        divClass={'col-12'}
                          name={"preferedShift"}
                          id={"preferedShift"}
                          options={masterData?.allPreferedShifts}
                          multiple={false}
                          value={shift.preferedShift ? [shift.preferedShift] : []}
                          updateValue={updateShiftDetails}
                          isObject={true}
                        /> :  props?.shiftHours ? shiftHoursCalc(props?.shiftHours):""
                      }
                     
                    </label>
                  </> :""
                 }
            </div>
            {/* email */}
            <div className="col-2">
              <label className="form-label">Department:</label>
              <label htmlFor="departmentDetails">
                          {props?.departmentDetails
                            ?.map((deps) => <p>{deps?.name}</p>)}
              </label>
            {/* <label className="form-label">Email:</label>
              <label
                    htmlFor={props?.claimedCandidateInfo?.email}
                  >
                    {props?.claimedCandidateInfo?.email}
              </label> */}
            </div>
            {/* Phone number */}
            <div className="col-2">
            {/* <label className="form-label">Phone number:</label>
              <label
                    htmlFor={props?.claimedCandidateInfo?.cellPhoneNumber}
                  >
                    {props?.claimedCandidateInfo?.cellPhoneNumber}
              </label> */}
            </div>
          </div>
        </div> }
             {/* sencond Row */}
             {props?.jobSummeryJobsShifts?.shiftType === 2 ? (
             ""
          ):<>
          {
            save && <div className="row">
            <div className="d-flex " >
              <div className="col-2" >
                <label className="form-label">Shift Start Date :</label>
                  <label htmlFor="Location Name">
               {props?.jobSummeryJobsShifts?.jobStartDateToDisplay}
                  </label>
              </div>
              <div className="col-2" >
                <label className="form-label">Shift Start Time :</label>
                  {save ?  <DropDown name={'startTime'}
                    divClass=" d-flex justify-content-start"
                    id={'startTime'}
                    options={masterData?.allShiftStartTime} multiple={false}
                    value={shift.startTime ? [shift?.startTime] : []}
                    updateValue={updateShiftDetails}
                    isObject={true}
                    errors={props.errors ? props?.errors['startTime'] : []}
                  /> :  <label htmlFor="Location Name">
                    {(props?.claimedCandidateInfo?.isClaimed && props?.claimedCandidateInfo?.jobDate)  ? moment(props?.claimedCandidateInfo?.jobDate).format("hh:mm A") : shiftStartTime }
                  </label>
                }
              </div>
              <div className="col-2" >
                <label className="form-label">Shift End Date :</label>
                  {(save &&+props?.requestData?.shiftType === shiftTypeObj.singleShift) ?  <DateField
                      isDisabled={true}
                      name={'endDate'}
                      divClass={`col-12'}`}
                      id={'enddate'}
                      value={shift?.endDate}
                      // updateValue={updateEndShiftDetails}
                      includeTime={false}
                    />:  <label htmlFor="Location Name">
                    {findPath?.pathname !== "/multiShiftJobInfo"? props?.jobEndDateToDisplay:props?.jobSummeryJobsShifts?.jobEndDateToDisplay}
                   </label>}
              </div>
              <div className="col-2"  >
                <label className="form-label">Shift End Time :</label>
                 { 
                 save ? <DropDown name={'endTime'}
                 divClass="d-flex justify-content-start"
                 id={'endTime'}
                 options={masterData?.allShiftEndTime} multiple={false}
                 value={shift.endTime ? [shift?.endTime] : []}
                 updateValue={updateShiftDetails}
                 isObject={true}
                 errors={props.errors ? props.errors['endTime'] : []}
               />: <label htmlFor="Location Name">
              {(props?.claimedCandidateInfo?.isClaimed && props?.claimedCandidateInfo?.jobEndDate) ? moment(props?.claimedCandidateInfo?.jobEndDate).format("hh:mm A") : shiftEndTime}
                 </label>
                 }
              </div>
              <div className="col-2"  >
                <label className="form-label">Current Shift Date :</label>
                  <label htmlFor="Location Name">
                  {moment(shiftDate).format("MM/DD/YYYY")}
                  </label>
              </div>
              <div className="col-2">
                 {
                  (save &&( +props?.payRateType  === payRateTypeObj.manualCal)) && <>
                     <label className="form-label" htmlFor="payRateTotalShiftAmount">
                        Total Shift Amount <span class="required">* </span>
                      </label>
                      <span
                        className={` form-control ${ payRateInputAmount&& "showDollar_input"}`}
                      >
                        <input
                          type="text"
                          placeholder="Enter Total Shift Amount"
                          className="showDollar_input_default "
                          name="payRateInputAmount"
                          id="payRateInputAmount"
                          value={payRateInputAmount ? formatNumberWithCommas(payRateInputAmount) : ""}
                          onChange={payRateShiftHandler}
                          onBlur={payRateShiftAmountHandler}
                        />
                      </span>
                      {isErrorPaymentRate && <div className="invalid-input">Enter a total shift amount.</div>} 
                  </>
                 }
              </div>
            </div>
          </div> 
          }
           </> }
        {/* row2-checkin details */}
        {save ? props?.jobSummeryJobsShifts?.shiftType !== 2 ? <>
          <div className="row">
          <div className="d-flex">
            <div className="col-2">
              <label className="form-label">Check In Date:</label>
                      <label
                        // style={{ background: `${props?.claimedCandidateInfo?.checkInStatus === 2 ? '#ffd300' : '#fff'}` }}
                        htmlFor={props?.claimedCandidateInfo?.checkedInDateToDisplay}
                      >
                        {props?.claimedCandidateInfo?.checkedInDateToDisplay ? moment(props?.claimedCandidateInfo?.checkedInDateToDisplay).format(
                          "MM/DD/YYYY"
                        ) : ("")}
                      </label>
            </div>
            <div className="col-2">
            <ToolTip position={"top"} value={props?.claimedCandidateInfo?.checkedInDateToolTipToDisplay}>
                <label style={{ cursor: "pointer" }} className="form-label">Check In Time:</label> 
              </ToolTip>
              <label
                   style={{background: `${props?.claimedCandidateInfo?.lateCheckedInTime && "#ffd300"}`}}
                      htmlFor={props?.claimedCandidateInfo?.checkedInDateToDisplay}
                      >
                        {props?.claimedCandidateInfo?.checkedInDateToDisplay ? moment(props?.claimedCandidateInfo?.checkedInDateToDisplay).format(
                          "hh:mm A"
                        ) : ("")} {props?.claimedCandidateInfo?.lateCheckedInTime && `(${props?.claimedCandidateInfo?.lateCheckedInTime})`}
                      </label>
            </div>
            <div className="col-2">
                <label className="form-label">Check Out Date:</label>
                      <label
                       htmlFor={props?.claimedCandidateInfo?.checkedOutDateToDisplay}
                      >
                        {props?.claimedCandidateInfo?.checkedOutDateToDisplay ? moment(props?.claimedCandidateInfo?.checkedOutDateToDisplay).format(
                          "MM/DD/YYYY"
                        ) : ("")}
                      </label>
            </div>
            <div className="col-2">
            <ToolTip position={"top"} value={props?.claimedCandidateInfo?.checkedOutDateToolTipToDisplay}>
                    <label style={{ cursor: "pointer" }} className="form-label">Check Out Time:</label> 
                </ToolTip>
                          <label 
                            style={{background: `${props?.claimedCandidateInfo?.lateCheckedOutTime && "#ffd300"}`}}
                          >
                            {props?.claimedCandidateInfo?.checkedOutDateToDisplay? moment(props?.claimedCandidateInfo?.checkedOutDateToDisplay).format(
                              "hh:mm A"
                            ) : ("")} {props?.claimedCandidateInfo?.lateCheckedOutTime && `(${props?.claimedCandidateInfo?.lateCheckedOutTime})`}
              </label>
            </div>
            <div className="col-2">
                <label className="form-label">Paid Date:</label>
                      <label>
                        {props?.claimedCandidateInfo?.paidDateToDisplay
                          ? moment(props?.claimedCandidateInfo?.paidDateToDisplay).format(
                              "MM/DD/YYYY"
                            )
                          : ""}
                      </label>
            </div>
            <div className="col-2">
              <label className="form-label">Paid Time:</label>
                      <label>
                        {props?.claimedCandidateInfo?.paidDateToDisplay
                          ? moment(props?.claimedCandidateInfo?.paidDateToDisplay).format("hh:mm A")
                          : ""}
                      </label>
            </div>
          </div>
        </div>
        </>:<>
        <div className="row">
          <div className="d-flex">
            <div className="col-2">
            <label className="form-label">Completed Date:</label>
                    <label>{props?.encounterCompletedDate}</label>
            </div>
            <div className="col-2">
                <label className="form-label">Paid Date:</label>
                      <label>
                        {props?.claimedCandidateInfo?.paidDateToDisplay
                          ? moment(props?.claimedCandidateInfo?.paidDateToDisplay).format(
                              "MM/DD/YYYY"
                            )
                          : ""}
                      </label>
            </div>
            <div className="col-2">
              <label className="form-label">Paid Time:</label>
                      <label>
                        {props?.claimedCandidateInfo?.paidDateToDisplay
                          ? moment(props?.claimedCandidateInfo?.paidDateToDisplay).format("hh:mm A")
                          : ""}
                      </label>
            </div>
            <div className="col-2"></div>
            <div className="col-2"></div>
            <div className="col-2"></div>
          </div>
        </div>
        </>:""}
                {/* INCENTIVE DETAILS */}
                {
            save && <ViewJobInfo save={save} {...props}/>
           }
        {/* <div className="row">
          <div className="d-flex">
            <div className="col-2">
              <label className="form-label">Check In Date:</label>
                      <label
                        style={{ background: `${props?.claimedCandidateInfo?.checkInStatus === 2 ? '#ffd300' : '#fff'}` }}
                        htmlFor={props?.claimedCandidateInfo?.checkedInDateToDisplay}
                      >
                        {props?.claimedCandidateInfo?.checkedInDateToDisplay ? moment(props?.claimedCandidateInfo?.checkedInDateToDisplay).format(
                          "MM/DD/YYYY"
                        ) : ("")}
                      </label>
            </div>
            <div className="col-2">
              <label className="form-label">Checked In Time:</label>
              <label
                  style={{ background: `${props?.claimedCandidateInfo?.checkInStatus === 2 ? '#ffd300' : '#fff'}` }}
                      htmlFor={props?.claimedCandidateInfo?.checkedInDateToDisplay}
                      >
                        {props?.claimedCandidateInfo?.checkedInDateToDisplay ? moment(props?.claimedCandidateInfo?.checkedInDateToDisplay).format(
                          "hh:mm A"
                        ) : ("")}
                      </label>
            </div>
            <div className="col-2">
                <label className="form-label">Check Out Date:</label>
                      <label
                       htmlFor={props?.claimedCandidateInfo?.checkedOutDateToDisplay}
                      >
                        {props?.claimedCandidateInfo?.checkedOutDateToDisplay ? moment(props?.claimedCandidateInfo?.checkedOutDateToDisplay).format(
                          "MM/DD/YYYY"
                        ) : ("")}
                      </label>
            </div>
            <div className="col-2">
              <label className="form-label">Check Out Time:</label>
                          <label>
                            {props?.claimedCandidateInfo?.checkedOutDateToDisplay? moment(props?.claimedCandidateInfo?.checkedOutDateToDisplay).format(
                              "hh:mm A"
                            ) : ("")}
              </label>
            </div>
            <div className="col-2">
                <label className="form-label">Paid Date:</label>
                      <label>
                        {props?.claimedCandidateInfo?.paidDateToDisplay
                          ? moment(props?.claimedCandidateInfo?.paidDateToDisplay).format(
                              "MM/DD/YYYY"
                            )
                          : ""}
                      </label>
            </div>
            <div className="col-2">
              <label className="form-label">Paid Time:</label>
                      <label>
                        {props?.claimedCandidateInfo?.paidDateToDisplay
                          ? moment(props?.claimedCandidateInfo?.paidDateToDisplay).format("hh:mm A")
                          : ""}
                      </label>
            </div>
          </div>
        </div> */}
        {/* row3-candidate details */}
        {/* <div className="row">
          {
            props?.jobSummeryJobsShifts?.shiftType !== 2 ? 
            <div className="d-flex">
            <div className="col-2">
            <label className="form-label">Candidate Work Duration Hours:</label>
                    <label
                      htmlFor= {props?.claimedCandidateInfo?.totalworkedHourToDisplay}
                    >
                    {props?.claimedCandidateInfo?.totalworkedHourToDisplay}
                    </label>
            </div>
            <div className="col-2">
              <label className="form-label">Employer Billing Rate:</label>
              <label>{props?.claimedCandidateInfo?.billingRateToDisplay}</label>
            </div>
            <div className="col-2">
            <label className="form-label">Employer Billing Amount:</label>
                  <label>
                  {props?.claimedCandidateInfo?.employerBillAmountToDisplay}
                  </label>
            </div>
            <div className="col-2">
            {
                    <>
                     <label className="form-label">
                     Candidate Payment Rate:
                      </label>
                      <label>
                      {props?.claimedCandidateInfo?.candidateRatePerHourToDisplay}
                      </label>
                    </>
                  }
            </div>
            <div className="col-2">
            {
                    props?.claimedCandidateInfo?.isCheckedOut === true ? <>
                     <label className="form-label">
                      Candidate Payable Amount:
                      </label>
                      <label>
                      {props?.claimedCandidateInfo?.candidateTotalAmountToDisplay}
                      </label>
                    </>:""
                  }
            </div>
            <div className="col-2">
                {
                   (props?.jobSummeryJobsShifts?.shiftType !== 2 && props?.claimedCandidateInfo?.billingRateToDisplay === "Variable") ? (
                    <>
                      <label className="form-label">Pay Rate:</label>
                      <ToolTip position={"top"} value={VariablePayRateTable}>
                      <i class="fa fa-question-circle" style={{ fontSize: "15px", marginTop: "4px", cursor: "pointer" }} aria-hidden="true"></i>
                      </ToolTip>
                    </>
                   ):""
                  }
            </div>
          </div>:
              <div className="d-flex">
              <div className="col-2">
                <label className="form-label">Employer Billing Rate:</label>
                <label>{props?.claimedCandidateInfo?.billingRateToDisplay}</label>
              </div>
              <div className="col-2">
              <label className="form-label">Employer Billing Amount:</label>
                    <label>
                    {props?.claimedCandidateInfo?.employerBillAmountToDisplay}
                    </label>
              </div>
              <div className="col-2">
              {
                      props?.claimedCandidateInfo?.isCheckedOut === true ? <>
                       <label className="form-label">
                        Candidate Payable Amount:
                        </label>
                        <label>
                        {props?.claimedCandidateInfo?.candidateTotalAmountToDisplay}
                        </label>
                      </>:""
                    }
              </div>
              <div className="col-2">
                  {
                     (props?.jobSummeryJobsShifts?.shiftType !== 2 && props?.claimedCandidateInfo?.billingRateToDisplay === "Variable") ? (
                      <>
                        <label className="form-label">Pay Rate:</label>
                        <ToolTip position={"top"} value={VariablePayRateTable}>
                        <i class="fa fa-question-circle" style={{ fontSize: "15px", marginTop: "4px", cursor: "pointer" }} aria-hidden="true"></i>
                        </ToolTip>
                      </>
                     ):""
                    }
              </div>
            </div>
          }
        </div> */}
            {/* row4x-modify SHIFT END time */}

           {props?.pageName === 'awaitingcorrection' &&
            <>
            {(window.location.pathname === '/awaitingcorrection' && props?.jobSummeryJobsShifts?.shiftType === shiftTypeObj?.dailyEnocunter) || (!props?.claimedCandidateInfo?.candidateUniqueId) ?
            "" : <WorkBreakInfo data={props}/>
            }
            </>
           }
          



           {props?.pageName !== 'awaitingcorrection' ? 
            <>
            <div className="row">
          <div className="d-flex">
            <div className="col">
            {props?.jobSummeryJobsShifts?.shiftType === 2 ? (""): (
            <div className="row">
                 { 
                //  props?.claimedCandidateInfo?.checkedInDate &&  
                //  props?.claimedCandidateInfo?.checkedOutDate  
                 props?.claimedCandidateInfo?.isCheckedIn
                 ? (
                  <>
                    <div className={"col-lg-4 col-md-4"}>
                      <ModifyCheckTime
                          // minTime = {getMinMaxTime(modifyTime?.shiftstarttime,0,0)}
                          // maxTime = {getMinMaxTime(modifyTime?.shiftstarttime,26,45)}
                        defaultRefDate = {claimedInfoRef.current?.jobDate}
                        updateValue = {modifyTimeChangeHandler}
                        modifyTime={modifyTime?.shiftstarttime}
                        label={"Shift Start Time:"}
                        name={"shiftstarttime"}
                        isDisabled = {
                          (props?.pageName === "shiftscoverage") ? true :
                          (props?.pageName === "completedShifts" || props?.pageName === "awaitingpayments" || props?.pageName === "openshifts") ? true :
                          (props?.pageName === "awaitingShifts") ? (props?.claimedCandidateInfo?.approversList?.some(
                            (item) =>{
                              if(item.approverUserUniqueId === login.appUserUniqueId){
                                return  item.isApproved === true
                               }
                            }
                          ) || !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)):
                          !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
                        
                        }
                      />
                   </div>
                   <div className={"col-lg-4 col-md-4"}>
                      <ModifyCheckTime
                          // minTime = {getMinMaxTime(modifyTime?.shiftstarttime,0,0)}
                          // maxTime = {getMinMaxTime(modifyTime?.shiftstarttime,maxShiftLengthHours,maxShiftLengthMinutes)}
                       defaultRefDate = {claimedInfoRef.current?.jobEndDate}
                        updateValue = {modifyTimeChangeHandler}
                        modifyTime={modifyTime?.shiftendtime}
                        label={"Shift End Time:"}
                        name={"shiftendtime"}
                        isDisabled = {
                          (props?.pageName === "shiftscoverage") ? true :
                          (props?.pageName === "openshifts" &&  props?.claimedCandidateInfo?.isCheckedOut) ? true : 
                          (props?.pageName === "openshifts" && props?.requestData?.occurrenceCorrectionType !== 0 && window.location.pathname === "/multiShiftJobInfo") ? true :
                          (props?.pageName === "completedShifts" || props?.pageName === "awaitingpayments") ? true :
                          (props?.pageName === "awaitingShifts" || props?.pageName ===  "shiftscoverage" || props?.pageName === "openshifts") ? (props?.claimedCandidateInfo?.approversList?.some(
                            (item) =>{
                              if(item.approverUserUniqueId === login.appUserUniqueId){
                                return  item.isApproved === true
                               }
                            }
                          ) || !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)) :
                          !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
                        
                        
                        }
                      />
                   </div>
                   {(props?.pageName === "shiftscoverage") ? '' : 
                   (props?.pageName === "openshifts" &&  props?.claimedCandidateInfo?.isCheckedOut) ? true :
                   (props?.pageName === "openshifts" && props?.requestData?.occurrenceCorrectionType !== 0 && window.location.pathname === "/multiShiftJobInfo") ? true :
                   (props?.pageName === "completedShifts" || props?.pageName === "awaitingpayments") ? "" :
                    <div className="col-lg-4 col-md-4 mt-4" style={{cursor:"pointer"}}>
                    <button
                      type="submit"
                      disabled={
                        (props?.pageName === "shiftscoverage") ? true :
                        (props?.pageName === "openshifts" &&  props?.claimedCandidateInfo?.isCheckedOut) ? true :
                        (props?.pageName === "awaitingShifts" ||  props?.pageName ===  "shiftscoverage" || props?.pageName === "openshifts") ? (props?.claimedCandidateInfo?.approversList?.some(
                          (item) =>{
                            if(item.approverUserUniqueId === login.appUserUniqueId){
                              return  item.isApproved === true
                             }
                          }
                        ) || !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)) :
                        !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
                      
                      }
                      className="btn btn-primary mt-4"
                      onClick={modiftShiftTimeHandler}
                    >
                      Submit
                    </button>
                  </div>
}
                  </>
                
                )
              :""}
            </div> )}
            </div>
          </div>
        </div>


        {/* row4-modify checkin time and checkout time */}
        <div className="row">
          <div className="d-flex">
            <div className="col">
            {props?.jobSummeryJobsShifts?.shiftType === 2 ? (""): (
            <div className="row">
                 { props?.claimedCandidateInfo?.checkedInDate &&  
                props?.claimedCandidateInfo?.checkedOutDate ? (
                  <>
                   <div className={"col-lg-4 col-md-4"}>
                      <ModifyCheckTime
                      // minTime = {getMinMaxTime(modifyTime?.shiftstarttime,0,beforeCheckIn)}
                      // maxTime = {getMinMaxTime(modifyTime?.shiftstarttime,maxShiftLengthHours,maxShiftLengthMinutes)}
                       defaultRefDate = {claimedInfoRef.current?.checkedInDate}
                        updateValue = {modifyTimeChangeHandler}
                        modifyTime={modifyTime?.checkintime}
                        label={"CheckIn Time:"}
                        name={"checkintime"}
                        isDisabled = {
                          (props?.pageName === "shiftscoverage") ? true :
                          (props?.pageName === "completedShifts" || props?.pageName === "awaitingpayments" || props?.pageName === "openshifts" ) ? true :
                          (props?.pageName === "awaitingShifts") ? (props?.claimedCandidateInfo?.approversList?.some(
                            (item) =>{
                              if(item.approverUserUniqueId === login.appUserUniqueId){
                                return  item.isApproved === true
                               }
                            }
                          ) || !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)):
                          !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)}
                      />
                   </div>
                   <div className={"col-lg-4 col-md-4"}>
                      <ModifyCheckTime
                          // minTime = {getMinMaxTime(modifyTime?.checkintime,0,0)}
                          // maxTime = {getMinMaxTime(modifyTime?.checkintime,maxShiftLengthHours,maxShiftLengthMinutes)}
                       defaultRefDate = {claimedInfoRef.current?.checkedOutDate}
                        updateValue = {modifyTimeChangeHandler}
                        modifyTime={modifyTime?.checkouttime}
                        label={"Checkout Time:"}
                        name={"checkouttime"}
                        isDisabled = {
                          (props?.pageName === "shiftscoverage") ? true :
                          (props?.pageName === "completedShifts" || props?.pageName === "awaitingpayments" || props?.pageName === "openshifts") ? true :
                          (props?.pageName === "awaitingShifts" ) ? (props?.claimedCandidateInfo?.approversList?.some(
                            (item) =>{
                              if(item.approverUserUniqueId === login.appUserUniqueId){
                                return  item.isApproved === true
                               }
                            }
                          ) || !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)):
                          !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)}
                      />
                   </div>
                   { (props?.pageName === "shiftscoverage") ? '' :
                   (props?.pageName === "completedShifts" || props?.pageName === "awaitingpayments" || props?.pageName === "openshifts") ? "" :
                    <div className="col-lg-4 col-md-4 mt-4" style={{cursor:"pointer"}}>
                    <button
                      type="submit"
                      disabled={
                        (props?.pageName === "awaitingShifts"  || props?.pageName ===  "shiftscoverage") ? (props?.claimedCandidateInfo?.approversList?.some(
                          (item) =>{
                            if(item.approverUserUniqueId === login.appUserUniqueId){
                              return  item.isApproved === true
                             }
                          }
                        ) || !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)):
                        !props?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)}
                      className="btn btn-primary mt-4"
                      onClick={submitModifyTimeHandler}
                    >
                      Submit
                    </button>
                  </div>
}
                  </>
                
                )
              :""}
            </div> )}
            </div>
          </div>
        </div>
                
      
      {/* Work Break Info */}
      {props?.pageName !== 'awaitingcorrection' ? 
      <div>
      <label className="form-label">Work Break Info:</label>
      {props?.jobBreakDetailsList?.length ?
        <table className="table" style={{width: '800px'}}>
          <thead>
            <tr>
            <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Break Type</th>
            <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Break Start Date / Time</th>
            <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Break End Date / Time</th>
            <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Break Duration</th>
            <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Paid Time</th>
            </tr>
          </thead>
          <tbody>
            {
              props?.jobBreakDetailsList?.map((item) => (
            <tr>
              <td className="text-center">{item.jobBreakType}</td>
              <td className="text-center">{item?.breakStartDateTime}</td>
              <td className="text-center">{item?.breakEndDateTime}</td>
              <td className="text-center">{item.jobBreakTypeDuration ? `${item.jobBreakTypeDuration} Hours` : ''}</td>
              <td className="text-center">{item.isPaidBreak ? 'Yes' : 'No'}</td>
            </tr>
              ))
            }
            
          </tbody>
        </table> : ''
}
      </div>
        : ''}


        {/* row5-Approvals */}
        <div className="row">
          <div className="d-flex">
            <div className="col">
            {!save &&  <label className="form-label">Approvals:</label>}
            {  props?.claimedCandidateInfo?.approversList?.map((item,index) => (
              <React.Fragment key={index}>
              <div className="form-group">
              <div className="row">
                <div className="col-2">
                  <label className="form-label">Approver:</label>
                  <label>{item?.approverName}</label>
                </div>
                <div className="col-2">
                  <label className="form-label">Approval Date:</label>
                  <label>{item?.approvedDateToDisplay}</label>
                </div>
                <div className="col-2">
                  <label className="form-label">Approved:</label>
                  <label>{item?.isApproved ? "Yes" : "No"}</label>
                </div>
                <div className="col-2">
                        <label className="form-label">Ratings:</label>
                          <Ratings
                          initialValue={item?.rating}
                           ratingValue={item?.rating}
                           readonly={true}
                           size={18}
                          />
                        </div>
                        {/* <div className="col-2">
                        <label className="form-label">Comments:</label>
                          <label style={{width: "100px"}}>{item?.notes}</label> 
                        </div> */}
                <div className="col-2  d-flex align-self-center">
                  {props?.claimedCandidateInfo?.isCheckedOut === true && (
                    <>
                {(props?.pageName === "completedShifts" || props?.pageName === "awaitingpayments" || props?.pageName === "openshifts" || props?.pageName === "shiftscoverage")? "" :
                  <div> 
                      {props?.jobSummeryJobsShifts?.shiftType === 2? (
                        <>
                          {(findPath?.pathname === "/daily-encounter-info" && props?.pageName === "awaitingshifts") ? "" : props?.allShiftCompleted ? (
                            <div className="d-flex flex-column gap-2">
                            <button
                              className="btn btn-primary "
                              onClick={(e) => showMap(e, item)}
                              disabled={
                                item?.approverUserUniqueId !==
                                login.appUserUniqueId
                              }
                            >
                              Approve with ratings 
                            </button>
                            <button
                              className="btn btn-primary "
                              onClick={() => {
                                saveRating(item);
                                setShowModal(false);
                              }}
                              disabled={
                                item?.approverUserUniqueId !==
                                login.appUserUniqueId
                              }
                            >
                              Approve without ratings
                            </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        <div className="d-flex flex-column gap-2">
                        <button
                          className="btn btn-primary "
                          onClick={(e) => showMap(e, item)}
                          disabled={
                            item?.approverUserUniqueId !==
                            login.appUserUniqueId
                          }
                        >
                          Approve with ratings
                        </button>
                        <button
                          className="btn btn-primary "
                          onClick={() => {
                            saveRating(item);
                            setShowModal(false);
                          }}
                          disabled={
                            item?.approverUserUniqueId !==
                            login.appUserUniqueId
                          }
                        >
                          Approve without ratings
                        </button>
                        </div>
                      )}
                    </div>}
                  </>
                  )}
                </div>
                <div className="col-2"></div>
                <div className="col-2"></div>
              </div>
              <div className="row">
              <div className="col">
                        <label className="form-label">Comments:</label>
                          <label>{item?.notes}</label> 
                        </div>
              </div>
            </div>
              </React.Fragment>
           )) }
            </div>
          </div>
        </div>
        {/* row6-BreakInfoDetails */}
        <div className="row">
            {/* While only showing the details after check out */}
            {props?.claimedCandidateInfo?.isCheckedOut === true ? (
              // While Break Info less then 0 don't Show the details
              props?.candidateBillingsInfo?.breakInfos?.length > 0 ? (
              <div className="col-10">
                {/* <div className="form-group">
                  <label className=" col-6 form-label">Break Info:</label>
                  <div className="d-flex">
                    <div className="col-3 border-bottom">
                      <label className="form-label">Start Time</label>
                    </div>
                    <div className="col-3 border-bottom">
                      <label className="form-label">End Time</label>
                    </div>
                    <div className="col-3 border-bottom">
                      <label className="form-label">Break Duration</label>
                    </div>
                  </div>
                  {props?.candidateBillingsInfo?.breakInfos?.map((item) => (
                    <div className="mt-2">
                      <div className="d-flex">
                        <div className="col-3 border-bottom">
                        <ToolTip position={"top"} value={item?.startTimeToolTipToDisplay}>
                          <label style={{ cursor: "pointer" }} htmlFor="City">
                            {item.startTimeToDisplay}
                          </label>
                        </ToolTip>
                        </div>
                        <div className="col-3 border-bottom">
                        <ToolTip position={"top"} value={item?.endTimeToolTipToDisplay}>
                          <label style={{ cursor: "pointer" }}  htmlFor="City">{item.endTimeToDisplay}</label>
                        </ToolTip>
                        </div>
                        <div className="col-3 border-bottom">
                          <label htmlFor="City">
                            {item.breakTimeToDisplay}
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div> */}
              </div>
              ) : ( "")

            ) : (
              ""
            )}
          </div>

          
          {/* row7-multishift details */}
          {(parseInt(props?.jobSummeryJobsShifts?.shiftType) === 3 || parseInt(props?.jobSummeryJobsShifts?.shiftType) === 4) ? 
           <div className="row">
           <div className="col-8">
             <div className="col-lg-8 col-md-8">
               <label label className="form-label">MultiShift:</label>
               <label htmlFor="City">{props?.rrurleStr}</label>
             </div>
           </div>
         </div>
          :""}
          {/* row8-multishift modified details */}
          {(parseInt(props?.jobSummeryJobsShifts?.shiftType) === 3 || parseInt(props?.jobSummeryJobsShifts?.shiftType) === 4 ) && props?.modifiedOccurreneList?.length? 
        <div class="row ">
          <div class="">
            <>
            {props?.deletedOccurence && props?.deletedOccurence?.length > 0 &&
                        <div className="form-group">
                                <label className="col-6 form-label">Deleted Occurrence:</label>
                                <ul>
                                {props?.deletedOccurence.map((item,index) =>
                                        <li key={index} className="col-6 text-decoration-line-through">{item}</li>
                                    )}
                                </ul>

                        </div>
                    }
                  
                    
                    {props?.modifiedOccurreneList && props?.modifiedOccurreneList?.length > 0 &&
                        <div className="form-group">
                            <label className="col-6 form-label">Modified Occurrence:</label>
                            <div  className='d-flex border-bottom'>
                                            <div className="col-2 text-center">
                                                <label className="form-label">Start Date</label>
                                            </div>
                                            <div className="col-2 text-center">
                                                <label className="form-label">End Date</label>
                                            </div>
                                            <div className="col-2 text-center">
                                                <label className="form-label">Start Time</label>
                                            </div>
                                            <div className="col-2 text-center">
                                                <label className="form-label">End Time</label>
                                            </div>
                                            <div className="col-2 text-center">
                                                <label className="form-label">Location Name</label>
                                            </div>
                                            {(+props?.payRateType === +payRateTypeObj.manualCal) && (
                                              <div className="col-2 text-center">
                                                <label className="form-label">
                                                  Amount Per Shift
                                                </label>
                                              </div>
                                            )}
                                           
                                        </div>
                            {props?.modifiedOccurreneList.map((item, index) =>
                                <>
                                      <div key={index} className='d-flex border-bottom pt-2 '>
                                            <div className="col-2 text-center">
                                                <label htmlFor="City">{item.startDateToDisplay}</label>
                                            </div>
                                            <div className="col-2 text-center">
                                                <label htmlFor="City">{item.endDateToDisplay}</label>
                                            </div>
                                            <div className="col-2 text-center">
                                                <label htmlFor="City">{item.startTime}</label>
                                            </div>
                                            <div className="col-2 text-center">
                                                <label htmlFor="City">{item.endTime}</label>
                                            </div>
                                            <div className="col-2 text-center">
                                                <label htmlFor="City">{item?.locationName}</label>
                                            </div>
                                            {(+props?.payRateType === +payRateTypeObj.manualCal) && (
                                              <div className="col-2 text-center">
                                               <label htmlFor="City">{item?.manualAmountPerShift ? `$ ${item?.manualAmountPerShift}` : ''}</label>
                                              </div>
                                            )}
                                        </div>
                                </>
                            )}
                        </div>
                    }
            </>
          </div>
        </div>:""}



        {/* row9- encounter details */}
        {props?.jobSummeryJobsShifts?.shiftType === 2 ? (
          <div>
          { props?.jobEncounterOccurreneList?.length > 0 ? (
            <div className="form-group">
                      <label className="col-6 form-label">
                        Encounter Occurrence:
                      </label>

                      <table className="table table-responsive">
                        <thead>
                          <tr className="border-bottom ">
                            <th className="text-capitalize">Date</th>
                            <th className="text-capitalize">Start Time</th>
                            <th className="text-capitalize">End Time</th>
                            <th className="text-capitalize">Check In Date</th>
                            <th className="text-capitalize">Check Out Date</th>
                            <th className="text-capitalize">Patient Name</th>
                            <th className="text-capitalize">Appointment Type</th>
                            <th className="text-capitalize">
                              Candidate Encounter Rate
                            </th>
                            <th className="text-capitalize">Employer Encounter Billing Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            props?.jobEncounterOccurreneList?.map((item, index) => {
                              return (
                                <tr className="border-bottom mt-2 bg-white">
                                  <td>{item.encounterStartToDisplay}</td>
                                  <td>{item.encounterStartTime} </td>
                                  <td>{item.encounterEndTime} </td>
                                  <td> <span style={{ background: `${item.encounterLateCheckedInTime && "#ffd300" }`}}> {item.checkedInDateToDisplay} {item.encounterLateCheckedInTime && `(${item.encounterLateCheckedInTime})`} </span></td>
                                  <td> <span style={{ background: `${item.encounterLateCheckedOutTime && "#ffd300" }`}}>{item.checkedOutDateToDisplay} {item.encounterLateCheckedOutTime && `(${item.encounterLateCheckedOutTime})`} </span></td>
                                  <td>{item.patientName}</td>
                                  <td>{item.appointmentTypeName}</td>
                                  <td>{item.candidateRatePerInstanceToDisplay ? `$ ${item.candidateRatePerInstanceToDisplay}`:item.candidateRatePerInstanceToDisplay}</td>
                                  <td>{item.employerRatePerInstanceToDisplay ? `$ ${item.employerRatePerInstanceToDisplay}`:item.employerRatePerInstanceToDisplay}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                    ) : ("")}
          </div>
        ) :""}

     
        </> : ''}

        {window.location.pathname === '/awaitingcorrection' && props?.jobSummeryJobsShifts?.shiftType === 2 ? 
        <>
        {props?.jobSummeryJobsShifts?.shiftType === 2 ? (
          <div>
          { props?.jobEncounterOccurreneList?.length > 0 ? (
            <div className="form-group">
                      <label className="col-6 form-label">
                        Encounter Occurrence:
                      </label>

                      <table className="table table-responsive">
                        <thead>
                          <tr className="border-bottom ">
                            <th className="text-capitalize">Date</th>
                            <th className="text-capitalize">Start Time</th>
                            <th className="text-capitalize">End Time</th>
                            <th className="text-capitalize">Check In Date</th>
                            <th className="text-capitalize">Check Out Date</th>
                            <th className="text-capitalize">Patient Name</th>
                            <th className="text-capitalize">Appointment Type</th>
                            <th className="text-capitalize">
                              Candidate Encounter Rate
                            </th>
                            <th className="text-capitalize">Employer Encounter Billing Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            props?.jobEncounterOccurreneList?.map((item, index) => {
                              return (
                                <tr className="border-bottom mt-2 bg-white">
                                  <td>{item.encounterStartToDisplay}</td>
                                  <td>{item.encounterStartTime} </td>
                                  <td>{item.encounterEndTime} </td>
                                  <td> <span style={{ background: `${item.encounterLateCheckedInTime && "#ffd300" }`}}> {item.checkedInDateToDisplay} {item.encounterLateCheckedInTime && `(${item.encounterLateCheckedInTime})`} </span></td>
                                  <td> <span style={{ background: `${item.encounterLateCheckedOutTime && "#ffd300" }`}}>{item.checkedOutDateToDisplay} {item.encounterLateCheckedOutTime && `(${item.encounterLateCheckedOutTime})`} </span></td>
                                  <td>{item.patientName}</td>
                                  <td>{item.appointmentTypeName}</td>
                                  <td>{item.candidateRatePerInstanceToDisplay ? `$ ${item.candidateRatePerInstanceToDisplay}`:item.candidateRatePerInstanceToDisplay}</td>
                                  <td>{item.employerRatePerInstanceToDisplay ? `$ ${item.employerRatePerInstanceToDisplay}`:item.employerRatePerInstanceToDisplay}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                    ) : ("")}
          </div>
        ) :""}

        <button
        onClick={() => completeCorrection()}
        className="btn btn-primary"
        disabled={
          props?.jobEncounterOccurreneList.some(item => item.checkedOutDate === null)
        }
        >
          Complete Correction
        </button>
        



        </>

        : ''}
      
  






      </div>
    </section>
  );
};

export default ViewClaimedCandidateInfo;
